export function getLocalDateStr(date) {
    return date.toLocaleDateString('en-CA'); // "YYYY-MM-DD" in local timezone
}

export function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
}

export function endOfWeek(date) {
    const d = new Date(date);
    const day = d.getDay();
    const diff = 7 - day;
    d.setDate(d.getDate() + diff);
    return d;
}

export function endOfMonth(date) {
    const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth() + 1, 0);
}

export function formatDueDate(dueDate) {
    const today = getLocalDateStr(new Date());
    const tomorrow = getLocalDateStr(addDays(new Date(), 1));
    if (dueDate === today) return 'Today';
    if (dueDate === tomorrow) return 'Tomorrow';
    const [year, month, day] = dueDate.split('-').map(Number);
    const d = new Date(year, month - 1, day);
    return d.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
}

export function formatDateHeader(dueDate) {
    const today = getLocalDateStr(new Date());
    const tomorrow = getLocalDateStr(addDays(new Date(), 1));
    if (dueDate === today) return 'Today';
    if (dueDate === tomorrow) return 'Tomorrow';
    const [year, month, day] = dueDate.split('-').map(Number);
    const d = new Date(year, month - 1, day);
    return d.toLocaleDateString('en-US', {weekday: 'short', month: 'short', day: 'numeric'});
}
